import React, { useState } from "react";
import LogoBig from "../../../Assets/LogoBig.png";
import { Link, useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [recaptchaValue, setRecaptchaValue] = useState("");

  const handleRecaptcha = (value) => {
    setRecaptchaValue(value);
  };

  const handleEmail = (event) => {
    setEmail(event.target.value.toLowerCase());
  };

  const handlePassword = (event) => {
    setPassword(event.target.value);
  };

  const apiUrl =
  process.env.REACT_APP_ENV === 'prod'
    ? process.env.REACT_APP_API_URL_PROD
    : process.env.REACT_APP_API_URL_PRE_PROD;


  const handleSubmit = (event) => {
    event.preventDefault();
    fetch(`${apiUrl}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, password: password, recaptchaValue: recaptchaValue }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json().then((data) => {
            if (data.access_token) {
              setIsLoggedIn(true);
              localStorage.setItem("token", data.access_token);
              localStorage.setItem("logged", "true");
              localStorage.setItem("email", email);
            } else {
              setError(data);
              console.log(error);
            }
          });
        }
        return res.json();
      })
      .catch((error) => {
        setError("An error occurred while logging in");
        console.error(error);
      });
    navigate("/mon-profil");
    window.location.reload();
  };

  return (
    <>
      <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8 login-wrapper">
        <div className="w-full max-w-md space-y-8">
          <div>
            <img className="mx-auto h-12 w-auto" src={LogoBig} alt="Logo" />
            <h2 className="mt-6 text-center text-3xl font-bold tracking-tight authentifciation-text ">
              Entrez vos informations d'identification pour accéder à votre
              compte
            </h2>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label htmlFor="email" className="sr-only">
                  Adresse e-mail
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={handleEmail}
                  required
                  className="relative p-16 block w-full appearance-none rounded-none rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Adresse e-mail"
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only ">
                  Mot de passe
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={handlePassword}
                  autoComplete="current-password"
                  required
                  className="relative p-16 block w-full appearance-none rounded-none rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Mot de passe"
                />
              </div>
            </div>

            <div className="flex items-center justify-center">
              {/*<div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                  Remember me
                </label>
              </div>*/}

              <div className="text-sm">
                <a
                  href="#"
                  className="font-medium text-indigo-600 hover:text-indigo-500 forgot-password"
                >
                  Forgot your password?
                </a>
              </div>
            </div>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              onChange={handleRecaptcha}
            />            
            <div>
              <button
                type="submit"
                className=" submit-button group relative flex w-full justify-center rounded-md border border-transparent  py-2 px-4 text-sm font-medium text-white  focus:outline-none focus:ring-2  focus:ring-offset-2"
              >
                {/*<span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <LockClosedIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" />
                </span>*/}
                Sign in
              </button>
            </div>
          </form>
          <div>
            <h5 className="text-center text-gray-100 register-text">
              {" "}
              Vous n'avez pas de compte?{" "}
              <span className=" register-span">
                <Link to="/inscription">Créer un compte</Link>
              </span>
            </h5>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
